import { Suspense } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { IntlProvider } from 'dibs-react-intl';
import { RelayEnvironmentProvider } from 'react-relay';
import serverVars from 'server-vars';
import { getBuyerId, getUserType } from 'dibs-cookie-jar';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import { addLoginHandlers } from 'dibs-buyer-layout/exports/loginHandlers.jsx';
import { TRADE } from 'dibs-buyer-layout/exports/userTypeEnums.ts';

import { TradeApplicationContainerLazy } from '../application/TradeApplicationContainerLazy.tsx';
import { TradeBenefitsNonTrade } from '../tradeBenefits/nonTrade/TradeBenefitsNonTrade.tsx';
import { TradeBenefits } from '../tradeBenefits/trade/TradeBenefits.tsx';
import { ServerVarsContextProvider } from '../shared/ServerVarsContext.tsx';
import { Loader } from '../shared/index.ts';
import { getEnvironment } from '../relayModernEnvironment.ts';

import '../shared/TradeAppContainer.scss';
import '../application/application.scss';

const locale = serverVars.get('locale');
const messages = serverVars.get('messages');
const isTradeBenefitsPageRedesign = serverVars.get('isTradeBenefitsPageRedesign');
const isTrade = serverVars.get('isTrade');

initializeDBL().then(() => {
    if (isTradeBenefitsPageRedesign) {
        if (!isTrade) {
            addLoginHandlers((authResponse?: { user?: { isVerifiedTrade?: boolean | null } }) => {
                if (getUserType(document.cookie) === TRADE || authResponse?.user?.isVerifiedTrade) {
                    window.location.reload();
                }
            });
        }

        const root = document.getElementById(isTrade ? 'rewardsContainer' : 'js-root');
        const userId = getBuyerId(document.cookie) || '';

        if (root) {
            const tree = (
                <IntlProvider locale={locale} messages={messages}>
                    <RelayEnvironmentProvider environment={getEnvironment(!isTrade)}>
                        <ServerVarsContextProvider
                            isDesktop={serverVars.get('settings.isDesktop')}
                            isMobile={serverVars.get('settings.isMobile')}
                            isTablet={serverVars.get('settings.isTablet')}
                            tradeBenefitsVideoPlaybackId={
                                serverVars.get('tradeBenefitsVideoPlaybackId') || ''
                            }
                        >
                            {isTrade ? (
                                <Suspense fallback={<Loader fullHeight />}>
                                    <TradeBenefits userId={userId} />
                                </Suspense>
                            ) : (
                                <TradeBenefitsNonTrade />
                            )}
                        </ServerVarsContextProvider>
                    </RelayEnvironmentProvider>
                </IntlProvider>
            );

            if (isTrade) {
                createRoot(root).render(tree);
            } else {
                hydrateRoot(root, tree);
            }
        }

        return;
    }

    const tradeAppNode = document.getElementById('tradeApp');

    if (tradeAppNode) {
        createRoot(tradeAppNode).render(
            <IntlProvider locale={locale} messages={messages}>
                <TradeApplicationContainerLazy />
            </IntlProvider>
        );
    }
});
